"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getFormulasReferredTheColumn", {
    enumerable: true,
    get: function() {
        return getFormulasReferredTheColumn;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getFormulasReferredTheColumn(context, { column, columns }, ncMeta = _Noco.default.ncMeta) {
    const fn = (pt)=>{
        if (pt.type === 'CallExpression') {
            return pt.arguments.some((arg)=>fn(arg));
        } else if (pt.type === 'Literal') {} else if (pt.type === 'Identifier') {
            return [
                column.id,
                column.title
            ].includes(pt.name);
        } else if (pt.type === 'BinaryExpression') {
            return fn(pt.left) || fn(pt.right);
        }
    };
    return columns.reduce(async (columnsPromise, c)=>{
        const columns = await columnsPromise;
        if (c.uidt !== _nocodbsdk.UITypes.Formula && c.uidt !== _nocodbsdk.UITypes.Button) return columns;
        const formula = await c.getColOptions(context, ncMeta);
        if (_nocodbsdk.UITypes.Button === c.uidt && (formula == null ? void 0 : formula.type) !== 'url') return columns;
        if (formula.formula && fn((0, _nocodbsdk.formulaJsep)(formula.formula))) {
            columns.push(c);
        }
        return columns;
    }, Promise.resolve([]));
}
